import {RemoteGetExamsProviderLocation} from 'data/usecases/private/booking-flow/exams/remote-get-exams-provider-location';
import {GetExamsProviderLocation} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamsProviderLocation = (): GetExamsProviderLocation =>
	new RemoteGetExamsProviderLocation(
		makeBFFApiUrl(BookingFlowEndPoints.examProviderLocation),
		makeAuthorizeHttpClientDecorator(),
	);
